// First, add the directive to your component
import { Eventstatus } from '../../shared/eventstatus';
import { EventconfigStoreService } from '../../shared/eventconfig-store.service';
import { EventsetupStoreService } from '../../shared/eventsetup-store.service';
import { Eventsetup } from '../../shared/eventsetup';
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import { AnimationEvent, animate, query, state, style, transition, trigger } from '@angular/animations';
import { Question } from '../../shared/question';
import { QuestionStoreService } from '../../shared/question-store.service';
import { environment } from '../../../environments/environment';
import { io, Socket } from 'socket.io-client';
import { ListReorderService } from '../../shared/list-reorder.service';

@Component({
  selector: 'lse-user-vote-question-list',
  templateUrl: './user-vote-question-list.component.html',
  styleUrls: ['./user-vote-question-list.component.css'],
  animations: [
    // Keep your existing animations for new items
    trigger('itemAnimation', [
      transition(':enter', [
        query('.opacity_target', [
          style({ opacity: 0 })
        ], { optional: true }),

        style({ height: 0 }),
        animate('1000ms ease-out', style({ height: '*' })),

        query('.opacity_target', [
          animate('1000ms ease-in', style({ opacity: 1 }))
        ], { optional: true })

      ]),
      transition(':leave', [
        query('.opacity_target', [
          animate('1000ms ease-in', style({ opacity: 0 }))
        ], { optional: true }),
        animate('900ms cubic-bezier(0.25, 0.46, 0.45, 0.94)', style({ height: 0 }))
      ])
    ]),
    trigger('slideInOut', [
      state(
        'in',
        style({
          overflow: 'hidden',
          height: '*'
        })
      ),
      state(
        'out',
        style({
          overflow: 'hidden',
          height: '0px'
        })
      ),
      transition('in => out', animate('250ms ease-in-out')),
      transition('out => in', animate('250ms ease-in-out'))
    ]),
trigger('noQuestionsContainerAnimation', [
  transition(':enter', [
    query('.opacity_target', [
      style({ opacity: 0 })
    ], { optional: true }),

    style({
      overflow: 'hidden',
      clipPath: 'inset(0 0 100% 0)'
    }),
    animate('1000ms cubic-bezier(0.22, 1, 0.36, 1)', style({
      clipPath: 'inset(0 0 0 0)'
    })),

    query('.opacity_target', [
      animate('1000ms ease-in', style({ opacity: 1 }))
    ], { optional: true })
  ]),
  transition(':leave', [
    query('.opacity_target', [
      animate('1000ms ease-in', style({ opacity: 0 }))
    ], { optional: true }),

    animate('900ms cubic-bezier(0.4, 0, 0.2, 1)', style({
      clipPath: 'inset(0 0 100% 0)'
    }))
  ])
])
  ]
})
export class UserVoteQuestionListComponent implements OnInit, OnDestroy {

  @Input() pageSize: number;
  @Input() eStatus: Eventstatus;
  @Input() user_vote_questions: boolean;
  @Output() playAtEvent = new EventEmitter();

  questions: Question[];

  page = 1;
  count = 0;

  holdMyTime: any;
  screenwidth = document.body.offsetWidth;
  eSetup: Eventsetup;
  eLangGlob: any;
  animationDisabled: boolean = true;
  realBackground: boolean = true;
  showUVQ = 'in';
  noQuestionsReady = false;
  activeItemAnimations = 0;
  noQuestionsVisibleAnimating = false;
  showList = true;

  didQuestionsExistBefore = false;

  questionsLoaded = false;

  vodHeight: any;
  // Socket-related properties
  public socket: Socket;
  resetTrackBy = 0;
  private noQuestionsReadyTimeout: ReturnType<typeof setTimeout> | null = null;
  private SOCKET_ENDPOINT = environment.apiUrl;
  private nodeServiceUrl = environment.production ? "event-backend" : "test-event-backend";

  constructor(
    private qs: QuestionStoreService,
    private ep: EventsetupStoreService,
    private es: EventconfigStoreService,
    protected listReorderService: ListReorderService,
    private questionStoreService: QuestionStoreService,
    private cdr: ChangeDetectorRef
  ) {
  }

  ngOnInit(): void {
    this.connectToSocketUVQ();
    this.eLangGlob = this.es.getLangGlobals();
    this.eSetup = this.ep.getStoredSetup();
    if(this.user_vote_questions){
      this.listReorderService.sortBy ='votes';
    }else {
      this.listReorderService.sortBy ='reverseDate';
    }

    this.noQuestionsReadyTimeout = setTimeout(() => {
      this.noQuestionsReady = true;
      this.noQuestionsReadyTimeout = null;
    }, 220);
    setTimeout(() => {
      this.animationDisabled = false;
      this.listReorderService.highlightStickyElements(this.questions);
      this.questionsLoaded = true;
    }, 200);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.screenwidth = window.innerWidth;
  }

  trackByFn = (index: number, item: Question): any => {
    return item.id + String(this.resetTrackBy);
  };

  get shouldShowNoQuestionsContainer(): boolean {
    const hasNoQuestions = !this.questions || this.questions.length === 0;
    return this.noQuestionsReady && hasNoQuestions;
  }

  connectToSocketUVQ() {
    this.socket = io(this.SOCKET_ENDPOINT + 'vote_question', {
      path: `/v1/${this.nodeServiceUrl}/socket/`,
      auth: {
        token: this.es.getInitCipher(),
        customer: environment.customerShort,
        instance: 'event'
      }
    });

    this.socket.on('change', (change: Question[]) => {
      const oldList = this.questions || [];

      if (oldList.length < change.length && oldList.length > 0 ) {
        this.resetListAndAddItems(oldList, change);
      } else{
        this.questions = this.listReorderService.performSortAnimation(oldList, change);
      }
      this.didQuestionsExistBefore = true;

      this.questionStoreService.questionsCount = change.length;
    });
  }

  ngOnDestroy() {
    if (this.noQuestionsReadyTimeout) {
      clearTimeout(this.noQuestionsReadyTimeout);
      this.noQuestionsReadyTimeout = null;
    }

    if (this.socket) {
      this.socket.disconnect();
    }
  }
  isLastItemInAnimation = false;

  handleEvent(value) {
    this.holdMyTime = value;
    this.playAtEvent.emit(value);
    // this.logger.log(value);
  }

  onItemAnimationStart() {
    if(this.questions.length==0){
      this.isLastItemInAnimation = true
    }
    this.realBackground = false;
  }

  onItemAnimationDone() {
      this.isLastItemInAnimation = false
    this.realBackground = this.activeItemAnimations === 0;
  }


  toggleUVQ() {
    this.showUVQ = this.showUVQ === 'out' ? 'in' : 'out';
  }

  // Resortier-Methode, die von außen aufgerufen werden kann
  public resortQuestions() {
    if (this.questions) {
      if (this.listReorderService.sortBy === 'votes'){
        this.questions = this.listReorderService.sortByVotes(this.questions);
        this.listReorderService.highlightStickyElements(this.questions);
      }
      else {
        this.questions = this.listReorderService.sortByTimestampAsc(this.questions);
        this.listReorderService.removeAllStickyFilters(this.questions);
      }

    }
  }

  private resetListAndAddItems(oldList: Question[], newList: Question[]) {
    this.animationDisabled = true;
    this.cdr.detectChanges(); // erzwingt Change Detection
    this.resetTrackBy++; // Force Angular to treat items as new
    this.cdr.detectChanges(); // erzwingt Change Detection
    this.animationDisabled = false;
    this.questions = this.listReorderService.performSortAnimation(oldList, newList);
    if(this.listReorderService.sortBy === 'votes'){
      this.listReorderService.highlightStickyElements(this.questions);
    }
    this.cdr.detectChanges(); // erzwingt Change Detection
  }
}
